// @generated by protoc-gen-es v2.9.0 with parameter "import_extension=js"
// @generated from file services/agent/resources/tool_call/tool_call.proto (package gx.agent.resources.tool_call, syntax proto3)
/* eslint-disable */

import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import { file_google_protobuf_struct } from "@bufbuild/protobuf/wkt";

/**
 * Describes the file services/agent/resources/tool_call/tool_call.proto.
 */
export const file_services_agent_resources_tool_call_tool_call = /*@__PURE__*/
  fileDesc("CjJzZXJ2aWNlcy9hZ2VudC9yZXNvdXJjZXMvdG9vbF9jYWxsL3Rvb2xfY2FsbC5wcm90bxIcZ3guYWdlbnQucmVzb3VyY2VzLnRvb2xfY2FsbCJCCg1UcmF2ZXJzYWxTdGVwEg8KB25vZGVfaWQYASABKAkSFAoHZWRnZV9pZBgCIAEoCUgAiAEBQgoKCF9lZGdlX2lkIkwKDkdyYXBoVHJhdmVyc2FsEjoKBXN0ZXBzGAEgAygLMisuZ3guYWdlbnQucmVzb3VyY2VzLnRvb2xfY2FsbC5UcmF2ZXJzYWxTdGVwIjQKDkdyYXBoSGlnaGxpZ2h0EhAKCG5vZGVfaWRzGAEgAygJEhAKCGVkZ2VfaWRzGAIgAygJIqcBChBHcmFwaEludGVyYWN0aW9uEkEKCXRyYXZlcnNhbBgBIAEoCzIsLmd4LmFnZW50LnJlc291cmNlcy50b29sX2NhbGwuR3JhcGhUcmF2ZXJzYWxIABJBCgloaWdobGlnaHQYAiABKAsyLC5neC5hZ2VudC5yZXNvdXJjZXMudG9vbF9jYWxsLkdyYXBoSGlnaGxpZ2h0SABCDQoLaW50ZXJhY3Rpb24ihAIKCFRvb2xDYWxsEgoKAmlkGAEgASgJEgwKBG5hbWUYAiABKAkSJQoEYXJncxgDIAEoCzIXLmdvb2dsZS5wcm90b2J1Zi5TdHJ1Y3QSJwoGcmVzdWx0GAQgASgLMhcuZ29vZ2xlLnByb3RvYnVmLlN0cnVjdBJOChFncmFwaF9pbnRlcmFjdGlvbhgFIAEoCzIuLmd4LmFnZW50LnJlc291cmNlcy50b29sX2NhbGwuR3JhcGhJbnRlcmFjdGlvbkgAiAEBEhgKC2Rlc2NyaXB0aW9uGAYgASgJSAGIAQFCFAoSX2dyYXBoX2ludGVyYWN0aW9uQg4KDF9kZXNjcmlwdGlvbiJHCglUb29sQ2FsbHMSOgoKdG9vbF9jYWxscxgBIAMoCzImLmd4LmFnZW50LnJlc291cmNlcy50b29sX2NhbGwuVG9vbENhbGxCkQIKIGNvbS5neC5hZ2VudC5yZXNvdXJjZXMudG9vbF9jYWxsQg1Ub29sQ2FsbFByb3RvUAFaTmdpdGh1Yi5jb20vZ2FsYXh5LWlvL2d4L3NoYXJlZC9nby9jb250cmFjdHMvc2VydmljZXMvYWdlbnQvcmVzb3VyY2VzL3Rvb2xfY2FsbKICBEdBUlSqAhtHeC5BZ2VudC5SZXNvdXJjZXMuVG9vbENhbGzKAhtHeFxBZ2VudFxSZXNvdXJjZXNcVG9vbENhbGziAidHeFxBZ2VudFxSZXNvdXJjZXNcVG9vbENhbGxcR1BCTWV0YWRhdGHqAh5HeDo6QWdlbnQ6OlJlc291cmNlczo6VG9vbENhbGxiBnByb3RvMw", [file_google_protobuf_struct]);

/**
 * Describes the message gx.agent.resources.tool_call.TraversalStep.
 * Use `create(TraversalStepSchema)` to create a new message.
 */
export const TraversalStepSchema = /*@__PURE__*/
  messageDesc(file_services_agent_resources_tool_call_tool_call, 0);

/**
 * Describes the message gx.agent.resources.tool_call.GraphTraversal.
 * Use `create(GraphTraversalSchema)` to create a new message.
 */
export const GraphTraversalSchema = /*@__PURE__*/
  messageDesc(file_services_agent_resources_tool_call_tool_call, 1);

/**
 * Describes the message gx.agent.resources.tool_call.GraphHighlight.
 * Use `create(GraphHighlightSchema)` to create a new message.
 */
export const GraphHighlightSchema = /*@__PURE__*/
  messageDesc(file_services_agent_resources_tool_call_tool_call, 2);

/**
 * Describes the message gx.agent.resources.tool_call.GraphInteraction.
 * Use `create(GraphInteractionSchema)` to create a new message.
 */
export const GraphInteractionSchema = /*@__PURE__*/
  messageDesc(file_services_agent_resources_tool_call_tool_call, 3);

/**
 * Describes the message gx.agent.resources.tool_call.ToolCall.
 * Use `create(ToolCallSchema)` to create a new message.
 */
export const ToolCallSchema = /*@__PURE__*/
  messageDesc(file_services_agent_resources_tool_call_tool_call, 4);

/**
 * Describes the message gx.agent.resources.tool_call.ToolCalls.
 * Use `create(ToolCallsSchema)` to create a new message.
 */
export const ToolCallsSchema = /*@__PURE__*/
  messageDesc(file_services_agent_resources_tool_call_tool_call, 5);

